<div class="deals-product position-relative">

    <div class="product-img mb-3">
        <img src="{{deal.image}}" alt="" class="img-fluid img-fit">
    </div>
    <div class="product-title px-3">
        <h6 class="text-truncate text-white">{{deal.name_en}}</h6>
    </div>
    <div class="product-info overflow-hidden p-3">
        <span class="category rounded-pill px-2">{{deal.brand.department.name_en}}</span>
        <span class="text-secondary-color font-weight-bold float-right product-price"> {{deal.description_en}} </span>
    </div>
</div>